import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useCheckpointAuthStore } from '../stores/checkpointAuthStore';
import Avatar from './Avatar';

function CheckpointLayout({ children, hideLayout = false }) {
    const navigate = useNavigate();
    const { user, logout } = useCheckpointAuthStore();

    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();

    // Adiciona classe ao body para garantir que o fundo seja claro
    useEffect(() => {
        document.body.classList.add('checkpoint-mobile-mode');
        return () => {
            document.body.classList.remove('checkpoint-mobile-mode');
        };
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/login', { replace: true });
    };

    if (hideLayout) {
        return (
            <div className="haklai-app-minimal">
                {children}
            </div>
        );
    }

    return (
        <div className="checkpoint-layout" style={{ 
            minHeight: '100vh', 
            display: 'flex', 
            flexDirection: 'column', 
            backgroundColor: '#f8f9fa'
        }}>
            {/* Header Simples e Premium */}
            <header style={{
                background: '#ffffff',
                padding: '16px 20px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                boxShadow: '0 2px 10px rgba(0,0,0,0.02)',
                position: 'sticky',
                top: 0,
                zIndex: 100
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <div className="sidebar-logo" style={{ 
                        width: '36px', height: '36px', 
                        background: 'linear-gradient(135deg, #0A58CA 0%, #043b8c 100%)',
                        color: 'white',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        borderRadius: '8px',
                        fontWeight: 'bold',
                        fontSize: '18px'
                    }}>
                        H
                    </div>
                    <div>
                        <div style={{ fontWeight: 700, color: '#111827', fontSize: '15px' }}>Haklai</div>
                        <div style={{ fontSize: '11px', color: '#6B7280', fontWeight: 500 }}>Portal do Líder</div>
                    </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{ textAlign: 'right', display: 'none' }} className="d-sm-block">
                            <div style={{ fontSize: '13px', fontWeight: 600, color: '#111827' }}>{user?.full_name || user?.name || 'Líder'}</div>
                        </div>
                        <Avatar name={user?.full_name || user?.name} size="sm" />
                    </div>
                    
                    <div style={{ position: 'relative' }}>
                        <button 
                            onClick={() => setMenuOpen(!menuOpen)}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: '#111827',
                                display: 'flex',
                                alignItems: 'center',
                                cursor: 'pointer',
                                padding: '4px'
                            }}
                            title="Menu"
                        >
                            <span className="material-symbols-outlined">menu</span>
                        </button>
                        
                        {menuOpen && (
                            <>
                                <div 
                                    style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, zIndex: 100 }}
                                    onClick={() => setMenuOpen(false)}
                                />
                                <div style={{
                                    position: 'absolute',
                                    top: '100%',
                                    right: 0,
                                    marginTop: '8px',
                                    background: 'white',
                                    borderRadius: '12px',
                                    boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                    padding: '8px',
                                    minWidth: '200px',
                                    zIndex: 101,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '4px'
                                }}>
                                    <button 
                                        onClick={() => { navigate('/select'); setMenuOpen(false); }}
                                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', background: 'none', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#111827', fontWeight: 500, textAlign: 'left', width: '100%' }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: '20px', color: location.pathname === '/select' ? '#0A58CA' : 'inherit' }}>dashboard</span>
                                        Início
                                    </button>
                                    <button 
                                        onClick={() => { navigate('/reports'); setMenuOpen(false); }}
                                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', background: 'none', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#111827', fontWeight: 500, textAlign: 'left', width: '100%' }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: '20px', color: location.pathname === '/reports' ? '#0A58CA' : 'inherit' }}>bar_chart</span>
                                        Relatórios
                                    </button>
                                    <button 
                                        onClick={() => { alert('Assistente Haklai em breve!'); setMenuOpen(false); }}
                                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', background: 'none', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#111827', fontWeight: 500, textAlign: 'left', width: '100%' }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>help</span>
                                        Ajuda
                                    </button>
                                    <div style={{ height: '1px', background: '#e5e7eb', margin: '4px 0' }} />
                                    <button 
                                        onClick={handleLogout}
                                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '12px', background: 'none', border: 'none', borderRadius: '8px', cursor: 'pointer', color: '#EF4444', fontWeight: 500, textAlign: 'left', width: '100%' }}
                                    >
                                        <span className="material-symbols-outlined" style={{ fontSize: '20px' }}>logout</span>
                                        Sair
                                    </button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </header>

            {/* Conteúdo Principal */}
            <main style={{ flex: 1, padding: '16px' }}>
                {children}
            </main>
        </div>
    );
}

export default CheckpointLayout;
